import SpriteSymbol from "../../../../../../../gitee/am-dropshipping-mb/ux/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../gitee/am-dropshipping-mb/ux/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_up",
  "use": "icon-ic_up-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 5\" id=\"icon-ic_up\">\n  <path fill-rule=\"evenodd\" d=\"M0.758,5.000 L5.000,0.757 L9.243,5.000 L0.758,5.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol